/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description hook for stripe customer portal
 */
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';

/**
 * use open payment portal
 */
const useOpenPaymentPortal = (): UseMutationResult<string, IAxiosError> => {
	return useMutation({
		mutationFn: async () => {
			const { data } = await api.Subscriptions.getCustomerURL({ redirectUrl: globalThis.location.href });
			return data;
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useOpenPaymentPortal;
